import { Box, Grid, Typography } from "@mui/material";
import styles from "../styles/TimelineRow.module.css";
import React from "react";
import { formatDateWithOptions } from "../lib/date";
import { MintingWindowState } from "../types/mint";

interface Props {
  name: string;
  tag: string;
  price: string;
  opensAt: number;
  window: string | null;
  currentState: MintingWindowState;
  rowState: MintingWindowState;
}
const TimelineRow = ({
  name,
  tag,
  price,
  opensAt,
  window,
  currentState,
  rowState,
}: Props) => {
  const date = new Date(opensAt);

  const getMintWindowContent = () => {
    if (currentState === rowState) {
      return (
        <>
          <Box className={styles.nowOpen}>Open Now</Box>
        </>
      );
    } else if (rowState < currentState) {
      return (
        <>
          <Box className={styles.closed}>Closed</Box>
        </>
      );
    } else {
      return (
        <>
          <Grid item className={styles.subtitle}>
            {formatDateWithOptions(date, {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </Grid>
          <Grid item className={styles.text}>
            <div>
              Opens{" "}
              {formatDateWithOptions(date, {
                hour: "numeric",
                minute: "numeric",
                timeZoneName: "short",
              })}
            </div>
            {window && <div>{window} mint window</div>}
          </Grid>
        </>
      );
    }
  };

  return (
    <Grid container item className={styles.row} mb={3} p={5} gap={3}>
      <Grid container item className={styles.item}>
        <Grid item className={styles.title}>
          Mint
        </Grid>
        <Grid item className={styles.subtitle}>
          {name}
        </Grid>
        <Grid item className={styles.text}>
          {tag}
        </Grid>
      </Grid>

      <Grid container item className={styles.item}>
        <Grid item className={styles.title}>
          Price
        </Grid>
        <Grid item className={styles.subtitle}>
          <Typography
            sx={{
              display: "inline",
              verticalAlign: "-12px",
              marginRight: "10px",
            }}
          >
            <img src="/images/mint/eth-black.svg" alt="eth icon" />
          </Typography>
          {price}
        </Grid>
        <Grid item className={styles.text}>
          + gas fees
        </Grid>
      </Grid>

      <Grid container item className={styles.item}>
        <Grid item className={styles.title}>
          Mint Window
        </Grid>
        {getMintWindowContent()}
      </Grid>
    </Grid>
  );
};

export default TimelineRow;
